const home =
{
        "checkout1": "اطلعوا",
        "checkout2": "على عروضنا ",
        "simulator1": "احسبوا",
        "simulator2": "قروضكم",
        "credit1": "اطلبوا",
        "credit2": "سلفا",
        "rdv1": "احجزوا",
        "rdv2": "موعدا",
        "remarque1": "شاركونا",
        "remarque2": "ملاحظاتكم",
        "select1": "المرجو اختيار",
        "select2": "إحدى خدماتنا",
        "copyright":"COPYRIGHT 2020 - GROUPE BANQUE POPULAIRE - TOUS DROITS RÉSERVÉS",
        "headerTitle1": "مرحبا بكم في",
        "headerTitle2": "فضاء المقاول الشعبي",
        "financingRequest": "لطلب سلف",
        "remarks":"لمشاركتنا ملاحظاتكم",
        "rdv":"لحجز الموعد",
        "financingTitle": "اطلبوا سلفا",
        "remarksTitle":"شاركونا ملاحظاتكم",
        "rdvTitle":"احجزوا موعدا"
}

export default home; 